import React from 'react';
import { useNavigate } from 'react-router-dom';

import { AttentionMessage } from '@eika/attention-message';
import { Icon, IconTypes } from '@eika/icon';
import { Link, LinkType } from '@eika/link';

import { Header } from '../../components/header/header';
import { StepNavigation } from '../../components/step-navigation/step-navigation';
import { SvgCardType } from '../../components/svg-card/svg-card-types';
import { useBankregnr } from '../../config';
import { SideType } from '../../utils/piwik-utils';

const hussoppenUrl = 'https://minside.hussoppen.no/?agent=eika';

const HussoppenInfo = () => (
    <div>
        <p>
            Vi samarbeider med fagekspertene fra Norsk Hussopp Forsikring og ønsker at du skal få den beste hjelpen til
            din skade.
        </p>
        <p>
            Du kan kontakte dem på telefon: <a href="tel:+4722283150">(+47) 22 28 31 50</a>
        </p>
        <p>Åpningstider: Mandag – fredag: 08:00 – 16:00</p>

        <p>
            Du kan også melde skaden din på{' '}
            <Link linkType={LinkType.INLINE} href={hussoppenUrl} target="_blank">
                Norsk Hussopp Forsikring
            </Link>
        </p>

        <p>
            <br />
            <Link
                icon={IconTypes.EKSTERN_DYN}
                linkType={LinkType.BUTTON_STANDARD_NEGATIVE}
                iconOnRightSide
                href={hussoppenUrl}
                target="_blank"
            >
                <Icon type={IconTypes.EKSTERN_24} className="link-icon-ekstern" />
                Meld skade hos Norsk Hussopp Forsikring
            </Link>
        </p>
    </div>
);

export const SoppRateSkadedyrInfo = () => {
    const bankregnr = useBankregnr();
    const title = 'Sopp, råte og skadedyr';

    const navigate = useNavigate();
    const goBack = () => navigate(-1);

    return (
        <>
            <Header svgCardType={SvgCardType.HusEnkelt} title={title} subtitle="Skademelding" />
            <AttentionMessage
                className="container__standard-width"
                id="SoppRateSkadedyrInfo-id"
                type="info"
                text={<HussoppenInfo />}
            />

            <StepNavigation
                bankregnr={bankregnr}
                next={{
                    onClick: null,
                    disabled: true,
                    hidden: true,
                }}
                prev={{ onClick: goBack }}
                sideDetail={{ type: SideType.Kategoriside, kategoriId: 'sopp-rate-skadedyr' }}
            />
        </>
    );
};
